<div class="relative flex flex-row h-full w-full" aria-labelledby="modal-title" role="dialog" aria-modal="true">

    <div class="absolute inset-0 z-10 overflow-hidden green-noise-bg flex items-center justify-center">

        <button type="button" (click)="closeCollaborators()"
            class="absolute top-2 left-2 z-20 rounded-full bg-zinc-200 dark:bg-zinc-600 p-1.5 sm:p-2 text-primary shadow-sm hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-5 sm:size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

        </button>

        <div class="relative w-[90%] h-[90%] primary-card-container flex flex-col overflow-hidden p-2 gap-y-2">
            <div aria-hidden="true" class="absolute inset-x-0 transform-gpu overflow-hidden blur-3xl sm:-top-80">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]">
                </div>
            </div>

            <div class="overflow-hidden h-full flex flex-col gap-y-2">


                <div class="shrink-0 z-10 w-full flex flex-row gap-x-4 p-2 justify-between card-container-pale">
                    <div class="w-full flex flex-wrap items-center justify-between sm:flex-nowrap">

                        <div class="flex items-center">
                            <div
                                class="shrink-0 size-12 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6">
                                    <path d="M16 5H3" />
                                    <path d="M11 12H3" />
                                    <path d="M16 19H3" />
                                    <path d="M18 9v6" />
                                    <path d="M21 12h-6" />
                                </svg>
                            </div>
                            <div class="ml-4">
                                <h3 class="text-sm font-semibold text-primary">Invite Creators to Collaborate on a
                                    Brief</h3>
                                <p class="text-xs text-secondary">
                                    Below are the creators you have selected. Select one or more briefs to invite them to.
                                </p>
                            </div>
                        </div>

                        <div class="flex shrink-0">
                            <!-- <button type="button"
                            class="rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-primary shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Button
                            text</button> -->
                        </div>
                    </div>
                </div>



                @if (confirmInvite() && selectedBriefCount() > 0) {
                <div class="flex-1 overflow-hidden flex flex-col items-center justify-center">
                    <div
                        class="shrink-0 z-10 w-full h-full rounded-2xl flex items-center justify-center primary-card-container">
                        @if (isProcessingInvites()) {
                        <atom-loading-inline title="Inviting Creators"
                            message="Sending invites to creators..."></atom-loading-inline>
                        } @else {
                        <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="mx-auto size-12 text-gray-400">
                                <path
                                    d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" />
                                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                                <path d="M12 17h.01" />
                            </svg>
                            <h3 class="mt-2 text-sm font-semibold text-primary">Invite {{
                                collaboratorsService.selectedCreators().length }} Creator{{
                                collaboratorsService.selectedCreators().length === 1 ? '' : 's' }} to {{
                                selectedBriefCount() }} brief{{ selectedBriefCount() === 1 ? '' : 's' }}
                            </h3>
                            <ul class="mt-3 space-y-1">
                                @for (brief of selectedBriefs(); track brief.id) {
                                <li>
                                    <p class="m-0 text-sm text-secondary">{{ brief.title }}</p>
                                </li>
                                }
                            </ul>
                            <div class="mt-6 flex flex-row gap-x-2 items-center justify-center">
                                <button type="button" (click)="confirmInvite.set(false)"
                                    class="secondary-button text-secondary">Cancel</button>
                                <button (click)="confirmInvitations()" type="button" class="primary-button">Send
                                    Invites</button>
                            </div>
                        </div>
                        }
                    </div>
                </div>
                } @else {
                <div class="flex-1 overflow-y-auto scrollbar-transparent flex flex-col gap-y-2">
                    <!-- Stats Section -->
                    <div class="shrink-0 z-10 w-full grid grid-cols-3 gap-x-2 card-container-pale">

                        <div class="overflow-hidden primary-card-container">
                            <div class="flex flex-row items-center justify-between flex-nowrap">
                                <div class="flex items-center flex-row gap-x-2">
                                    <div
                                        class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-6">
                                            <path
                                                d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                    </div>
                                    <div class="">
                                        <h3 class="text-sm font-semibold text-primary">Potential Reach</h3>
                                    </div>
                                </div>
                                <div class="flex shrink-0 gap-x-2">

                                </div>
                            </div>
                            <div class="px-3 pb-1 flex items-center justify-center flex-col">
                                <h3 class="mx-auto text-md font-semibold text-accent">{{ getPotentialReach() | number }}</h3>
                                <p class="mx-auto text-xs text-secondary">Total Followers</p>
                            </div>
                        </div>

                        <div class="overflow-hidden primary-card-container">
                            <div class="flex flex-row items-center justify-between flex-nowrap">
                                <div class="flex items-center flex-row gap-x-2">
                                    <div
                                        class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-6">
                                            <path
                                                d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5" />
                                        </svg>
                                    </div>
                                    <div class="">
                                        <h3 class="text-sm font-semibold text-primary">Average Engagement</h3>
                                    </div>
                                </div>
                                <div class="flex shrink-0 gap-x-2">

                                </div>
                            </div>
                            <div class="px-3 pb-1 flex items-center justify-center flex-col">
                                <h3 class="mx-auto text-md font-semibold text-accent">{{ getAverageEngagement() |
                                    number: '1.2-2' }}%</h3>
                                <p class="mx-auto text-xs text-secondary">Avg. Engagement Rate</p>
                            </div>
                        </div>

                        <div class="overflow-hidden primary-card-container">
                            <div class="flex flex-row items-center justify-between flex-nowrap">
                                <div class="flex items-center flex-row gap-x-2">
                                    <div
                                        class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-6">
                                            <path
                                                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                                        </svg>
                                    </div>
                                    <div class="">
                                        <h3 class="text-sm font-semibold text-primary">Quality Score</h3>
                                    </div>
                                </div>
                                <div class="flex shrink-0 gap-x-2">

                                </div>
                            </div>
                            <div class="px-3 pb-1 flex items-center justify-center flex-col">
                                @if (getAverageRating(); as average) {
                                <h3 class="mx-auto text-md font-semibold text-accent">{{ average | number: '1.1-1' }}</h3>
                                <p class="mx-auto text-xs text-secondary">Avg. Rating</p>
                                } @else {
                                <h3 class="mx-auto text-md font-semibold text-accent">New</h3>
                                <p class="mx-auto text-xs text-secondary">No reviews yet</p>
                                }
                            </div>
                        </div>
                    </div>
                    <!-- Stats Section END -->


                    <!-- Creator List -->
                    <div class="flex-1 z-10 w-full grid grid-cols-12 rounded-2xl gap-x-2 overflow-hidden">
                        <div
                            class="col-span-7 divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden flex flex-col primary-card-container">
                            <div class="flex flex-row items-center justify-between flex-nowrap px-2 pt-1 pb-2">
                                <div class="flex items-center flex-row gap-x-2">
                                    <div
                                        class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                            <circle cx="9" cy="7" r="4" />
                                        </svg>
                                    </div>
                                    <div class="flex flex-col">
                                        <h3 class="text-sm font-semibold text-primary">Selected Creators</h3>
                                        <p class="text-xs text-secondary">
                                            Below are the creators you have selected to invite to a brief.
                                        </p>
                                    </div>
                                </div>
                                <div class="flex shrink-0 gap-x-2 text-transparent">
                                    @if (collaboratorsService.selectedCreators() &&
                                    collaboratorsService.selectedCreators().length > 0) {
                                    <p class="text-xs text-secondary truncate">{{
                                        collaboratorsService.selectedCreators().length }} Selected</p>
                                    }
                                </div>
                            </div>
                            <div class="py-2 flex flex-col gap-y-2 flex-1 overflow-hidden">
                                <div class="space-y-2 h-full overflow-y-auto scrollbar-hide">
                                    @if (collaboratorsService.selectedCreators() &&
                                    collaboratorsService.selectedCreators().length > 0) {
                                    <ul role="list" class="gap-y-1 flex flex-col">
                                        @for (creator of collaboratorsService.selectedCreators(); track $index) {
                                        <li class="flex items-center justify-between gap-x-6 card-container-pale">
                                            <div class="flex min-w-0 gap-x-4">

                                                <div class="size-10 flex-none rounded-full bg-gray-50 overflow-hidden">
                                                    <atom-ldg-img inputClass="object-cover" w="full" radius="full"
                                                        [src]="imageService.getImageSource(creator.photoURL, 'gallery_xl')"></atom-ldg-img>
                                                </div>
                                                <div class="min-w-0 flex-auto">
                                                    <p class="text-sm font-semibold text-primary">{{ creator.firstName
                                                        }} {{ creator.lastName.charAt(0) }}.
                                                    </p>
                                                    <div class="inline-flex gap-x-1.5 items-end">
                                                        @if (creatorRating(creator); as rating) {
                                                        <p class="text-xs text-secondary">{{ rating | number: '1.1-1' }} Star</p>
                                                        <p class="truncate text-xs text-secondary">| {{ creator['total_reviews'] }} {{ creator['total_reviews'] === 1 ? 'review' : 'reviews' }}</p>
                                                        } @else {
                                                        <p class="text-xs text-secondary">New creator · no reviews yet</p>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex flex-row gap-x-2 items-center">

                                                <!-- <span class="inline-flex items-center rounded-m px-2 py-1 text-xs font-medium bg-gray-200 dark:bg-gray-400/10 text-gray-400 inset-ring inset-ring-gray-400/20">Badge</span> -->

                                                <span
                                                    class="inline-flex items-center rounded-m px-2 py-1 text-xs font-medium rounded-full bg-gray-100 dark:bg-gray-400/10 text-secondary inset-ring inset-ring-gray-400/20">{{
                                                    formatService.convertIntToString(creator.tikTokFollowers +
                                                    creator.instaFollowers +
                                                    creator.snapchatFollowers + creator.youtubeSubscribers) }}
                                                    Followers</span>
                                                <span
                                                    class="inline-flex items-center rounded-m px-2 py-1 text-xs font-medium rounded-full bg-gray-100 dark:bg-gray-400/10 text-secondary inset-ring inset-ring-gray-400/20">{{
                                                    getAvgEngaegement(creator) | number:
                                                    '1.2-2' }}% Avg. Engagement</span>


                                                <button type="button"
                                                    (click)="collaboratorsService.removeCreator(creator)"
                                                    class="fab-button-secondary">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                        class="size-4">
                                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
                                                        <path d="M3 6h18" />
                                                        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </li>
                                        }
                                    </ul>
                                    }
                                    @else if (collaboratorsService.selectedCreators() &&
                                    collaboratorsService.selectedCreators().length == 0) {
                                    <div class="w-full h-full flex items-center justify-center">
                                        <div class="text-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="mx-auto size-12 text-gray-400">
                                                <circle cx="10" cy="7" r="4" />
                                                <path d="M10.3 15H7a4 4 0 0 0-4 4v2" />
                                                <circle cx="17" cy="17" r="3" />
                                                <path d="m21 21-1.9-1.9" />
                                            </svg>
                                            <h3 class="mt-2 text-sm font-semibold text-primary">No Creators Selected
                                            </h3>
                                            <p class="mt-1 text-sm text-secondary">Select creators to invite to a brief.
                                            </p>
                                            <div class="mt-6">
                                                <button (click)="closeCollaborators()" type="button"
                                                    class="inline-flex items-center rounded-md bg-primary px-3 py-1 text-xs font-semibold text-white shadow-sm hover:bg-primary/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
                                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon"
                                                        aria-hidden="true" class="-ml-0.5 mr-1.5 size-4">
                                                        <path
                                                            d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                                                    </svg>
                                                    Select Creators
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                    }
                                    @else {
                                    No creators selected.
                                    }
                                </div>
                            </div>
                        </div>

                        @if (collaboratorsService.briefId()) {
                        <div
                            class="col-span-5 divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden flex flex-col primary-card-container">
                            <div class="flex flex-row items-center justify-between flex-nowrap px-2 py-2">
                                <div class="flex items-center flex-row gap-x-2">
                                    <div
                                        class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path
                                                d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                            <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                            <path d="m9 15 2 2 4-4" />
                                        </svg>
                                    </div>
                                    <div class="flex flex-col">
                                        <h3 class="text-sm font-semibold text-primary">Invite to Brief</h3>
                                        <p class="text-xs text-secondary">
                                            Inviting creators to the focussed brief.
                                        </p>
                                    </div>
                                </div>
                                <div class="flex shrink-0 gap-x-2 text-transparent">

                                </div>
                            </div>
                            <div class="px-2 py-2 flex flex-col gap-y-2 flex-1 overflow-hidden">
                                @if (specificBriefSelected()) {
                                <div class="flex-1 space-y-2 h-full overflow-y-auto scrollbar-hide">

                                    <!-- Brief Overview -->
                                    <div
                                        class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden rounded-lg border bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-zinc-700">
                                        <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                                            <div class="flex items-center flex-row gap-x-2">
                                                <div
                                                    class="shrink-0 size-8 rounded-full bg-gray-50 flex items-center justify-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                        class="size-5">
                                                        <path
                                                            d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                                        <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                                        <path d="m9 15 2 2 4-4" />
                                                    </svg>
                                                </div>
                                                <div class="">
                                                    <h3 class="text-sm font-semibold text-primary">Brief Overview
                                                    </h3>
                                                </div>
                                            </div>
                                            <div class="flex shrink-0 gap-x-2 text-transparent">
                                                RHS
                                            </div>
                                        </div>
                                        <div class="flex flex-col w-full py-3 px-3 gap-y-3">

                                            <div class="flex flex-col w-full">
                                                <h3 class="text-sm font-semibold text-primary">{{
                                                    specificBriefSelected()?.title }}</h3>
                                            </div>

                                            <div class="w-full grid grid-cols-3 gap-2">
                                                <div class="col-span-1">
                                                    <p class="text-xs font-light text-secondary">Status</p>
                                                    <p class="text-xs text-primary">{{ getBriefStatus() }}</p>
                                                </div>

                                                <div class="col-span-1">
                                                    <p class="text-xs font-light text-secondary">Video Format</p>
                                                    <p class="text-xs text-primary">{{ getVideoFormat() }}</p>
                                                </div>

                                                <div class="col-span-1">
                                                    <p class="text-xs font-light text-secondary">Duration</p>
                                                    <p class="text-xs text-primary">{{ getVideoDuration() }}</p>
                                                </div>

                                                <div class="col-span-1">
                                                    <p class="text-xs font-light text-secondary">Videos / Creator</p>
                                                    <p class="text-xs text-primary">{{ briefAsk().videoCount }}</p>
                                                </div>

                                                <div class="col-span-1">
                                                    <p class="text-xs font-light text-secondary">{{ briefAsk().source === 'pieces' ? 'Placements' : 'Channel' }}</p>
                                                    <p class="text-xs text-primary">{{ briefAsk().detail }}</p>
                                                </div>
                                                @if (briefAsk().source === 'pieces') {
                                                <div class="col-span-1">
                                                    <p class="text-xs font-light text-secondary">Posts</p>
                                                    <p class="text-xs text-primary">{{ briefAsk().postCount }}</p>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Brief Overview END -->

                                    <!-- Campaign Overview -->
                                    <div
                                        class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden rounded-lg border bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-zinc-700">
                                        <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                                            <div class="flex items-center flex-row gap-x-2">
                                                <div
                                                    class="shrink-0 size-8 rounded-full bg-gray-50 flex items-center justify-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                        class="size-5">
                                                        <path
                                                            d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" />
                                                    </svg>
                                                </div>
                                                <div class="">
                                                    <h3 class="text-sm font-semibold text-primary">Campaign</h3>
                                                </div>
                                            </div>
                                            <div class="flex shrink-0 gap-x-2 text-transparent">

                                            </div>
                                        </div>
                                        <div class="px-3 py-3">
                                            <div class="flex items-center flex-row gap-x-4">
                                                <div
                                                    class="relative flex-shrink-0 size-16 rounded-full outline outline-1 -outline-offset-1 outline-black/5">
                                                    <atom-ldg-img inputClass="object-cover" w="full" h="full"
                                                        radius="full"
                                                        [src]="imageService.getImageSource(specificBriefSelected()?.campaign?.campaignPhoto, 'gallery')"></atom-ldg-img>
                                                </div>

                                                <div class="flex flex-col">
                                                    <h3 class="text-sm text-primary">{{
                                                        specificBriefSelected()?.campaign?.campaignName }}</h3>
                                                    <p class="text-xs text-secondary line-clamp-2">{{
                                                        specificBriefSelected()?.campaign?.campaignDescription
                                                        }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Campaign Overview END -->

                                    <!-- Product Overview -->
                                    <div
                                        class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden rounded-lg border bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-zinc-700">
                                        <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                                            <div class="flex items-center flex-row gap-x-2">
                                                <div
                                                    class="shrink-0 size-8 rounded-full bg-gray-50 flex items-center justify-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                        class="size-5">
                                                        <path
                                                            d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
                                                        <path d="M12 22V12" />
                                                        <polyline points="3.29 7 12 12 20.71 7" />
                                                        <path d="m7.5 4.27 9 5.15" />
                                                    </svg>
                                                </div>
                                                <div class="">
                                                    <h3 class="text-sm font-semibold text-primary">Product</h3>
                                                </div>
                                            </div>
                                            <div class="flex shrink-0 gap-x-2 text-transparent">

                                            </div>
                                        </div>
                                        <div class="px-3 py-3">
                                            <div class="flex items-center flex-row gap-x-4">
                                                <div
                                                    class="relative flex-shrink-0 size-16 rounded-full outline outline-1 -outline-offset-1 outline-black/5">
                                                    <atom-ldg-img inputClass="object-cover" w="full" h="full"
                                                        radius="full"
                                                        [src]="imageService.getImageSource(specificBriefSelected()?.product?.productImage, 'gallery')"></atom-ldg-img>
                                                </div>

                                                <div class="flex flex-col">
                                                    <h3 class="text-sm text-primary">{{
                                                        specificBriefSelected()?.product?.productName }}</h3>
                                                    <p class="text-xs text-secondary line-clamp-2">{{
                                                        specificBriefSelected()?.product?.productDescription
                                                        }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Product Overview END -->
                                </div>

                                } @else {
                                <div class="h-full w-full flex items-center justify-center">
                                    <atom-loading-inline title="Focussing Brief"
                                        message="Will be with you in a moment..." />
                                </div>
                                }
                            </div>
                        </div>
                        } @else {
                        <div
                            class="col-span-5 divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden flex flex-col primary-card-container">
                            <div class="flex flex-row items-center justify-between flex-nowrap px-2 pt-1 pb-2">
                                <div class="flex items-center flex-row gap-x-2">
                                    <div
                                        class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path
                                                d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                            <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                            <path d="m9 15 2 2 4-4" />
                                        </svg>
                                    </div>
                                    <div class="flex flex-col">
                                        <h3 class="text-sm font-semibold text-primary">Select Briefs</h3>
                                        <p class="text-xs text-secondary">
                                            Select one or more briefs to invite creators to.
                                        </p>
                                    </div>
                                </div>
                                <div class="flex shrink-0 gap-x-2">
                                    @if (selectedBriefCount() > 0) {
                                    <p class="m-0 text-xs text-secondary">{{ selectedBriefCount() }} selected</p>
                                    }
                                </div>
                            </div>
                            <div class="px-2 py-1 flex flex-col gap-y-2 flex-1 overflow-hidden">
                                <div class="relative shrink-0 pt-2 w-full">
                                    <button type="button" (click)="selectCampaignOpen.set(!selectCampaignOpen())"
                                        class="grid w-full grid-cols-1 pr-2 pl-3 text-left text-primary dropdown-select-primary-btn"
                                        aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label">
                                        @if (selectedCampaign()) {
                                        <span class="col-start-1 row-start-1 flex w-full gap-2 pr-6">
                                            <span class="text-xs truncate">{{ selectedCampaign()?.campaignName }}</span>
                                            <span class="truncate text-secondary"></span>
                                        </span>
                                        } @else {
                                        <span class="col-start-1 row-start-1 flex w-full gap-2 pr-6">
                                            <span class="text-xs truncate">Select Campaign</span>
                                            <span class="truncate text-secondary"></span>
                                        </span>
                                        }

                                        <svg class="col-start-1 row-start-1 size-5 self-center justify-self-end text-secondary sm:size-4"
                                            viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" data-slot="icon">
                                            <path fill-rule="evenodd"
                                                d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </button>

                                    @if (selectCampaignOpen() && campaigns() && campaigns()!.length > 0) {
                                    <ul class="absolute z-10 mt-1 max-h-60 w-full overflow-auto dropdown-select-primary-menu-old w-full"
                                        tabindex="-1" role="listbox" aria-labelledby="listbox-label"
                                        aria-activedescendant="listbox-option-3">
                                        @for (campaign of campaigns(); track campaign.id) {

                                        <li (click)="selectCampaign(campaign)"
                                            class="relative cursor-default py-1 px-2 text-primary select-none hover:bg-gray-100 dark:hover:bg-gray-700"
                                            id="listbox-option-0" role="option">
                                            <div class="flex items-center">
                                                <img class="size-5 flex-none rounded-md bg-gray-50 shrink-0"
                                                    [src]="imageService.getImageSource(campaign.campaignPhoto, 'gallery')"
                                                    alt>
                                                <span class="ml-2 text-xs block truncate font-normal">{{
                                                    campaign.campaignName }}</span>
                                            </div>
                                            @if (selectedCampaign() && selectedCampaign()?.id === campaign.id) {
                                            <span
                                                class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent">
                                                <svg class="size-5" viewBox="0 0 20 20" fill="currentColor"
                                                    aria-hidden="true" data-slot="icon">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </span>
                                            }
                                        </li>
                                        }
                                    </ul>
                                    }

                                </div>
                                <div class="min-h-0 flex-1 space-y-2 overflow-y-auto scrollbar-hide">
                                    <div class="h-full space-y-2 overflow-y-auto scrollbar-hide">
                                        @if (displayBriefs() && displayBriefs()!.length > 0) {
                                        <ul role="list" class="flex flex-col gap-y-1">
                                            @for (brief of displayBriefs(); track brief.id) {
                                            <li (click)="selectBrief(brief)"
                                                class="flex items-center justify-between gap-x-6 card-container-pale cursor-pointer"
                                                role="checkbox"
                                                [attr.aria-checked]="isBriefSelected(brief)">

                                                <div class="min-w-0 flex-auto">
                                                    <p class="text-sm font-semibold text-primary">{{ brief.title }}
                                                    </p>
                                                    <p class="truncate text-xs text-secondary">
                                                        {{ brief.campaign.campaignName }}</p>
                                                </div>

                                                @if (isBriefSelected(brief)) {
                                                <svg class="size-6 text-green-500" xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                                    <path fill-rule="evenodd"
                                                        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                                        clip-rule="evenodd" />
                                                </svg>

                                                } @else {
                                                <svg class="size-6 text-secondary" xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512" aria-hidden="true">
                                                    <circle cx="256" cy="256" r="192" fill="none" stroke="currentColor"
                                                        stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="32" />
                                                </svg>
                                                }
                                            </li>
                                            }
                                        </ul>
                                        } @else {
                                        <div class="flex h-full items-center justify-center">
                                            <p class="m-0 text-center text-xs text-secondary">
                                                @if (selectedCampaign()) {
                                                No live briefs in this campaign.
                                                } @else {
                                                No live briefs to invite to yet.
                                                }
                                            </p>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                    </div>
                    <!-- Creator List END -->
                </div>
                }


                <!-- <div class="shrink-0 z-10 w-full flex flex-row bg-white rounded-2xl border border-gray-300 dark:border-zinc-700 gap-x-4 p-2 justify-between"> -->
                <div class="shrink-0 z-10 w-full flex flex-row gap-x-4 p-2 justify-between card-container-pale">

                    <!-- <button type="button" (click)="closeCollaborators()" class="rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-primary shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Close</button> -->
                    <div class="flex flex-row gap-x-2 items-center">
                        <button type="button" (click)="closeCollaborators()"
                            class="secondary-button text-secondary">Close</button>
                    </div>


                    <div class="flex flex-row gap-x-2 items-center">


                        <button type="button" (click)="clearSelection()" class="secondary-button text-secondary">Clear
                            Selection</button>

                        <button type="button" (click)="inviteCreators()" [disabled]="!canInvite()"
                            class="primary-button">Invite
                            Creators</button>
                    </div>


                </div>


            </div>

            <div aria-hidden="true"
                class="absolute inset-x-0 top-[calc(100%-13rem)] transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]">
                </div>
            </div>

        </div>
    </div>
</div>